import type { OSVersion } from '../schema/OSVersion';

/**
 * Returns Android version
 */
export const getAndroidVersion = () => {
    let version: OSVersion = null;

    if (!window?.navigator) {
        return version;
    }

    const userAgent = window.navigator.userAgent.toLowerCase();
    const versionsArray = userAgent.match(/android\s([0-9\.]*)/i);
    if (versionsArray) {
        const versions = versionsArray[1].split('.');

        version = {
            major: parseInt(versions[0] || '0', 10),
            minor: parseInt(versions[1] || '0', 10),
            patch: parseInt(versions[2] || '0', 10),
        };
    }

    return version;
};
